import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.8484 9.05953C17.2297 9.45903 17.215 10.092 16.8155 10.4734L11.3154 15.7234C10.929 16.0922 10.3209 16.0922 9.93449 15.7234L7.18452 13.0984C6.78503 12.717 6.77031 12.084 7.15165 11.6845C7.53299 11.285 8.16599 11.2703 8.56548 11.6516L10.625 13.6176L15.4345 9.02664C15.834 8.64531 16.467 8.66003 16.8484 9.05953Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
    }, null, -1)
  ])))
}
export default { render: render }